import gql from 'graphql-tag'
import api from '../apiClient'

export default {
  create: (item, profile) =>
    api
      .send({
        query: gql`
          mutation create($item: EmisorInput!, $profile: String!) {
            Emisor {
              create(input: $item, profile: $profile) {
                id
                nombre
                identificacion {
                  tipo {
                    id
                  }
                  numero
                }
                nombreComercial
                local {
                  id
                  numero
                  terminal {
                    id
                    numero
                  }
                }
                ubicacion {
                  provincia {
                    id
                  }
                  canton {
                    id
                  }
                  distrito {
                    id
                  }
                  otrasSenas
                }
                telefono {
                  codigoPais
                  numTelefono
                }
                correoElectronico
                usernameATV
                passwordATV
                certificadoATV
                pin
                certificadoExpiracion
                codigoActividad {
                  documento {
                    id
                    value
                    annotation
                  }
                  codigoActividad {
                    id
                    value
                    annotation
                  }

                  condicionVenta {
                    id
                    value
                    annotation
                  }
                  plazoCredito
                  medioPago {
                    id
                    value
                    annotation
                  }

                  clasificacion
                  cabys
                  modoivaIncluido
                  editarServicios
                  editarPrecios
                  modoLibre

                  codigo {
                    id
                    value
                  }
                  codigoTarifa {
                    id
                  }
                  tarifa
                  codigoMoneda {
                    id
                    value
                    simbolo
                  }
                  unidadMedida {
                    id
                  }
                }
                restaurantModule
                cashRegisterModule
                productionModule
                bulkBillingModule
                billingModule
                crmModule
                marketingModule
                inventoryModule
                viajesModule
                accountingModule
                whatsappModule
              }
            }
          }
        `,
        variables: {
          item,
          profile
        }
      })
      .then(result => result.data.data.Emisor.create),

  setNotification: (_id, notification) =>
    api
      .send({
        query: gql`
          mutation setNotification($_id: ID!, $notification: NotificationInput!) {
            Emisor {
              setNotification(_id: $_id, notification: $notification)
            }
          }
        `,
        variables: {
          _id,
          notification
        }
      })
      .then(result => result.data.data.Emisor.setNotification),

  setLinks: (_id, links) =>
    api
      .send({
        query: gql`
          mutation setLinks($_id: ID!, $links: LinksInput!) {
            Emisor {
              setLinks(_id: $_id, links: $links)
            }
          }
        `,
        variables: {
          _id,
          links
        }
      })
      .then(result => result.data.data.Emisor.setLinks),

  //  lee emisor el usuario logueado.
  readByUserId: id =>
    api
      .send({
        query: gql`
          query read($id: ID!) {
            User {
              readById(id: $id) {
                emisor {
                  id
                  img
                  nombre
                  identificacion {
                    tipo {
                      id
                    }
                    numero
                  }
                  nombreComercial
                  local {
                    id
                    numero
                    terminal {
                      id
                      numero
                    }
                  }
                  ubicacion {
                    provincia {
                      id
                    }
                    canton {
                      id
                    }
                    distrito {
                      id
                    }
                    otrasSenas
                  }
                  telefono {
                    codigoPais
                    numTelefono
                  }
                  correoElectronico
                  usernameATV
                  passwordATV
                  certificadoATV
                  pin
                  certificadoExpiracion
                  codigoActividad {
                    documento {
                      id
                      value
                      annotation
                    }
                    codigoActividad {
                      id
                      value
                      annotation
                    }

                    condicionVenta {
                      id
                      value
                      annotation
                    }
                    plazoCredito
                    medioPago {
                      id
                      value
                      annotation
                    }

                    clasificacion
                    cabys
                    modoivaIncluido
                    editarServicios
                    editarPrecios
                    modoLibre
                    codigo {
                      id
                      value
                      annotation
                    }
                    codigoTarifa {
                      id
                      value
                      annotation
                    }
                    tarifa
                    codigoMoneda {
                      id
                      value
                      simbolo
                    }
                    unidadMedida {
                      id
                    }
                  }
                  restaurantModule
                  cashRegisterModule
                  productionModule
                  bulkBillingModule
                  billingModule
                  crmModule
                  marketingModule
                  inventoryModule
                  viajesModule
                  accountingModule
                  whatsappModule
                }
              }
            }
          }
        `,
        variables: {
          id
        }
      })
      .then(result => result.data.data.User.readById),

  readNotification: _id =>
    api
      .send({
        query: gql`
          query readNotification($_id: ID!) {
            Emisor {
              readNotification(_id: $_id) {
                orderEmail
                orderSMS
              }
            }
          }
        `,
        variables: {
          _id
        }
      })
      .then(result => result.data.data.Emisor.readNotification),

  readLinks: _id =>
    api
      .send({
        query: gql`
          query readLinks($_id: ID!) {
            Emisor {
              readLinks(_id: $_id) {
                name
                enablePaymentLink
                paymentUrl
                paymentRedirectUrl
                paymentType
                onvoSecret

                enableNewCustomerLink
                newCustomerUrl
              }
            }
          }
        `,
        variables: {
          _id
        }
      })
      .then(result => result.data.data.Emisor.readLinks),

  /*readPrinters: _id =>
    api
      .send({
        query: gql`
          query readPrinters($_id: ID!) {
            Emisor {
              readPrinters(_id: $_id) {
                _id
                name
                ip
                model
              }
            }
          }
        `,
        variables: {
          _id
        }
      })
      .then(result => result.data.data.Emisor.readPrinters),*/

  setPrinter: (_id, printer) =>
    api
      .send({
        query: gql`
          mutation setPrinter($_id: ID!, $printer: PrinterInput!) {
            Emisor {
              setPrinter(_id: $_id, printer: $printer)
            }
          }
        `,
        variables: {
          _id,
          printer
        }
      })
      .then(result => result.data.data.Emisor.setPrinter),

  readLinkByName: link =>
    api
      .send({
        query: gql`
          query readLinkByName($link: String!) {
            Emisor {
              readLinkByName(link: $link) {
                enablePaymentLink
                paymentUrl
                paymentRedirectUrl
                paymentType
                onvoSecret
              }
            }
          }
        `,
        variables: {
          link
        }
      })
      .then(result => result.data.data.Emisor.readLinkByName),

  readFacturasMesByEmisor: (emisor, documento, codigoMoneda) =>
    api
      .send({
        query: gql`
          query readFacturasMesByEmisor($emisor: ID!, $documento: [String!], $codigoMoneda: CodigoMonedaInput!) {
            Factura {
              readFacturasMesByEmisor(emisor: $emisor, documento: $documento, codigoMoneda: $codigoMoneda) {
                createdAt {
                  year
                  month
                }
                totalComprobante
              }
            }
          }
        `,
        variables: {
          emisor,
          documento,
          codigoMoneda
        }
      })
      .then(result => result.data.data.Factura.readFacturasMesByEmisor),

  readSumaMontosFacturasMesByEmisor: (emisor, codigoMoneda) =>
    api
      .send({
        query: gql`
          query readSumaMontosFacturasMesByEmisor($emisor: ID!, $codigoMoneda: CodigoMonedaInput!) {
            Factura {
              readSumaMontosFacturasMesByEmisor(emisor: $emisor, codigoMoneda: $codigoMoneda) {
                documento
                total
              }
            }
          }
        `,
        variables: {
          emisor,
          codigoMoneda
        }
      })
      .then(result => result.data.data.Factura.readSumaMontosFacturasMesByEmisor),

  readSumaMontosFacturasAceptadasMesByEmisor: (emisor, codigoMoneda) =>
    api
      .send({
        query: gql`
          query readSumaMontosFacturasAceptadasMesByEmisor($emisor: ID!, $codigoMoneda: CodigoMonedaInput!) {
            Factura {
              readSumaMontosFacturasAceptadasMesByEmisor(emisor: $emisor, codigoMoneda: $codigoMoneda) {
                documento
                total
              }
            }
          }
        `,
        variables: {
          emisor,
          codigoMoneda
        }
      })
      .then(result => result.data.data.Factura.readSumaMontosFacturasAceptadasMesByEmisor),

  readSumaMontosFacturasMesyAnteriorByEmisor: (emisor, codigoMoneda) =>
    api
      .send({
        query: gql`
          query readSumaMontosFacturasMesyAnteriorByEmisor($emisor: ID!, $codigoMoneda: CodigoMonedaInput!) {
            Factura {
              readSumaMontosFacturasMesyAnteriorByEmisor(emisor: $emisor, codigoMoneda: $codigoMoneda) {
                prev {
                  month
                  total
                }
                current {
                  month
                  total
                }
              }
            }
          }
        `,
        variables: {
          emisor,
          codigoMoneda
        }
      })
      .then(result => result.data.data.Factura.readSumaMontosFacturasMesyAnteriorByEmisor),

  readVentasDiarias: (emisor, codigoMoneda) =>
    api
      .send({
        query: gql`
          query readVentasDiarias($emisor: ID!, $codigoMoneda: CodigoMonedaInput!) {
            Factura {
              readVentasDiarias(emisor: $emisor, codigoMoneda: $codigoMoneda) {
                day
                total
              }
            }
          }
        `,
        variables: {
          emisor,
          codigoMoneda
        }
      })
      .then(result => result.data.data.Factura.readVentasDiarias),

  readStatsByEmisor: emisor =>
    api
      .send({
        query: gql`
          query readStatsByEmisor($emisor: ID!) {
            Factura {
              readStatsByEmisor(emisor: $emisor) {
                estadoDocumento {
                  annotation
                }
                count
              }
            }
          }
        `,
        variables: {
          emisor
        }
      })
      .then(result => result.data.data.Factura.readStatsByEmisor),

  checkToken: (username, password) =>
    api
      .send({
        query: gql`
          query checkToken($username: String!, $password: String!) {
            Emisor {
              checkToken(username: $username, password: $password)
            }
          }
        `,
        variables: {
          username,
          password
        }
      })
      .then(result => result.data.data.Emisor.checkToken),

  readEmisorByDomain: domain =>
    api
      .send({
        query: gql`
          query read($domain: String!) {
            Emisor {
              readEmisorByDomain(domain: $domain) {
                id
                nombre
                nombreComercial
                accountingModule
              }
            }
          }
        `,
        variables: {
          domain
        }
      })
      .then(result => result.data.data.Emisor.readEmisorByDomain),

  readById: id =>
    api
      .send({
        query: gql`
        query readById($id: ID!) {
          User {
            readById(id: $id) {
              emisor {
                id
                nombre
                identificacion {
                  tipo {
                    id
                  }
                  numero
                }
                nombreComercial
                local {
                  id
                  numero
                  terminal {
                    id
                    numero
                  }
                }
                ubicacion {
                  provincia {
                    id
                  }
                  canton {
                    id
                  }
                  distrito {
                    id
                  }
                  otrasSenas
                }
                telefono {
                  codigoPais
                  numTelefono
                }
                correoElectronico
                codigoActividad {
                  codigoActividad {
                    id
                    value
                    annotation
                  }
                }
              }
            }
          }
        }
      `,
        variables: { id }
      })
      .then(result => result.data.data.User.readById.emisor),

  setModules: (
    emisor,
    restaurantModule,
    cashRegisterModule,
    productionModule,
    bulkBillingModule,
    billingModule,
    crmModule,
    marketingModule,
    inventoryModule,
    viajesModule,
    accountingModule,
    whatsappModule
  ) =>
    api
      .send({
        query: gql`
          mutation setModules(
            $emisor: ID!
            $restaurantModule: Boolean!
            $cashRegisterModule: Boolean!
            $productionModule: Boolean!
            $bulkBillingModule: Boolean!
            $billingModule: Boolean!
            $crmModule: Boolean!
            $marketingModule: Boolean!
            $inventoryModule: Boolean!
            $viajesModule: Boolean!
            $accountingModule: Boolean!
            $whatsappModule: Boolean!
          ) {
            Emisor {
              setModules(
                emisor: $emisor
                restaurantModule: $restaurantModule
                cashRegisterModule: $cashRegisterModule
                productionModule: $productionModule
                bulkBillingModule: $bulkBillingModule
                billingModule: $billingModule
                crmModule: $crmModule
                marketingModule: $marketingModule
                inventoryModule: $inventoryModule
                viajesModule: $viajesModule
                accountingModule: $accountingModule
                whatsappModule: $whatsappModule
              )
            }
          }
        `,
        variables: {
          emisor,
          restaurantModule,
          cashRegisterModule,
          productionModule,
          bulkBillingModule,
          billingModule,
          crmModule,
          marketingModule,
          inventoryModule,
          viajesModule,
          accountingModule,
          whatsappModule
        }
      })
      .then(result => result.data.data.Emisor.setModules)
}
